import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from './toast.service';

@Component({
    selector: 'app-toasts',
    standalone: true,
    imports: [NgbToastModule, NgTemplateOutlet, CommonModule],
    templateUrl: './toasts-container.component.html',
    host: {
        class: 'd-flex w-100 align-items-center flex-column toast-container position-fixed start-0 top-0 end-0 p-3',
        style: 'z-index: 1200',
    },
})
export class ToastsContainer {
    toastService = inject(ToastService);

    isTemplate(toast: any) {
        return toast.textOrTpl instanceof TemplateRef;
    }
}
